module.exports = __webpack_public_path__ + "img/align-right.e565b404.svg";